import { render, staticRenderFns } from "./InjectionModal.vue?vue&type=template&id=b67b272c"
import script from "./InjectionModal.vue?vue&type=script&lang=js"
export * from "./InjectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports